export const us_phone_code = [
  "+1205",
  "+1251",
  "+1256",
  "+1334",
  "+1907",
  "+1480",
  "+1520",
  "+1602",
  "+1623",
  "+1928",
  "+1479",
  "+1501",
  "+1870",
  "+1209",
  "+1213",
  "+1310",
  "+1323",
  "+1408",
  "+1415",
  "+1424",
  "+1510",
  "+1530",
  "+1559",
  "+1562",
  "+1619",
  "+1626",
  "+1650",
  "+1661",
  "+1707",
  "+1714",
  "+1760",
  "+1805",
  "+1818",
  "+1831",
  "+1858",
  "+1909",
  "+1916",
  "+1925",
  "+1949",
  "+1951",
  "+1303",
  "+1719",
  "+1720",
  "+1970",
  "+1203",
  "+1860",
  "+1302",
  "+1202",
  "+1689",
  "+1239",
  "+1305",
  "+1321",
  "+1352",
  "+1386",
  "+1407",
  "+1561",
  "+1727",
  "+1754",
  "+1772",
  "+1786",
  "+1813",
  "+1850",
  "+1863",
  "+1904",
  "+1941",
  "+1954",
  "+1762",
  "+1229",
  "+1404",
  "+1478",
  "+1678",
  "+1706",
  "+1770",
  "+1912",
  "+1808",
  "+1208",
  "+1730",
  "+1779",
  "+1217",
  "+1224",
  "+1309",
  "+1312",
  "+1447",
  "+1618",
  "+1630",
  "+1708",
  "+1773",
  "+1815",
  "+1847",
  "+1219",
  "+1260",
  "+1317",
  "+1574",
  "+1765",
  "+1812",
  "+1319",
  "+1515",
  "+1563",
  "+1641",
  "+1712",
  "+1316",
  "+1620",
  "+1785",
  "+1913",
  "+1270",
  "+1502",
  "+1606",
  "+1859",
  "+1225",
  "+1318",
  "+1337",
  "+1504",
  "+1985",
  "+1207",
  "+1240",
  "+1301",
  "+1410",
  "+1443",
  "+1339",
  "+1351",
  "+1413",
  "+1508",
  "+1617",
  "+1774",
  "+1781",
  "+1857",
  "+1978",
  "+1231",
  "+1248",
  "+1269",
  "+1313",
  "+1517",
  "+1586",
  "+1616",
  "+1734",
  "+1810",
  "+1906",
  "+1947",
  "+1989",
  "+1218",
  "+1320",
  "+1507",
  "+1612",
  "+1651",
  "+1763",
  "+1952",
  "+1228",
  "+1601",
  "+1662",
  "+1769",
  "+1314",
  "+1417",
  "+1573",
  "+1636",
  "+1660",
  "+1816",
  "+1406",
  "+1308",
  "+1402",
  "+1702",
  "+1775",
  "+1603",
  "+1201",
  "+1551",
  "+1609",
  "+1732",
  "+1848",
  "+1856",
  "+1862",
  "+1908",
  "+1973",
  "+1505",
  "+1575",
  "+1212",
  "+1315",
  "+1347",
  "+1516",
  "+1518",
  "+1585",
  "+1607",
  "+1631",
  "+1646",
  "+1716",
  "+1718",
  "+1845",
  "+1914",
  "+1917",
  "+1252",
  "+1336",
  "+1704",
  "+1828",
  "+1910",
  "+1919",
  "+1980",
  "+1701",
  "+1216",
  "+1234",
  "+1330",
  "+1419",
  "+1440",
  "+1513",
  "+1567",
  "+1614",
  "+1740",
  "+1937",
  "+1405",
  "+1580",
  "+1918",
  "+1503",
  "+1541",
  "+1971",
  "+1215",
  "+1267",
  "+1412",
  "+1484",
  "+1570",
  "+1610",
  "+1717",
  "+1724",
  "+1814",
  "+1878",
  "+1401",
  "+1803",
  "+1843",
  "+1864",
  "+1605",
  "+1423",
  "+1615",
  "+1731",
  "+1865",
  "+1901",
  "+1931",
  "+1210",
  "+1214",
  "+1254",
  "+1281",
  "+1325",
  "+1361",
  "+1409",
  "+1430",
  "+1432",
  "+1469",
  "+1512",
  "+1682",
  "+1713",
  "+1806",
  "+1817",
  "+1830",
  "+1832",
  "+1903",
  "+1915",
  "+1936",
  "+1940",
  "+1956",
  "+1972",
  "+1979",
  "+1435",
  "+1801",
  "+1802",
  "+1276",
  "+1434",
  "+1540",
  "+1571",
  "+1703",
  "+1757",
  "+1804",
  "+1206",
  "+1253",
  "+1360",
  "+1425",
  "+1509",
  "+1681",
  "+1304",
  "+1262",
  "+1414",
  "+1608",
  "+1715",
  "+1920",
  "+1307",
];

export const speech_phrases = [
  "primary care physician",
  "annual wellness visit",
  "high blood pressure",
  "hypertension",
  "type 2 diabetes",
  "hyperlipidemia",
  "high cholesterol",
  "obesity",
  "BMI",
  "blood sugar",
  "blood glucose",
  "HbA1c",
  "fasting blood sugar",
  "pre-diabetes",
  "insulin resistance",
  "heart disease",
  "coronary artery disease",
  "chest pain",
  "shortness of breath",
  "palpitations",
  "congestive heart failure",
  "COPD",
  "asthma",
  "oxygen saturation",
  "inhaler",
  "nebulizer",
  "allergy testing",
  "allergic rhinitis",
  "sinus infection",
  "sinusitis",
  "ear infection",
  "bronchitis",
  "strep throat",
  "sore throat",
  "COVID test",
  "flu vaccine",
  "pneumonia vaccine",
  "Tdap",
  "shingles vaccine",
  "colonoscopy",
  "mammogram",
  "pap smear",
  "prostate exam",
  "urinary tract infection",
  "UTI",
  "bladder infection",
  "frequent urination",
  "burning during urination",
  "blood in urine",
  "kidney function test",
  "electrolyte imbalance",
  "liver enzymes",
  "fatty liver",
  "gastroesophageal reflux disease",
  "acid reflux",
  "GERD",
  "stomach pain",
  "bloating",
  "diarrhea",
  "constipation",
  "irritable bowel syndrome",
  "IBS",
  "Crohn's disease",
  "ulcerative colitis",
  "gluten intolerance",
  "lactose intolerance",
  "food allergy",
  "migraine",
  "headache",
  "dizziness",
  "vertigo",
  "vision problems",
  "hearing loss",
  "numbness",
  "tingling",
  "muscle cramps",
  "joint pain",
  "arthritis",
  "rheumatoid arthritis",
  "osteoporosis",
  "bone density scan",
  "DEXA scan",
  "Vitamin D deficiency",
  "B12 deficiency",
  "fatigue",
  "anemia",
  "low iron",
  "thyroid function",
  "hypothyroidism",
  "hyperthyroidism",
  "TSH test",
  "sleep apnea",
  "snoring",
  "CPAP",
  "depression",
  "anxiety",
  "mental health",
  "therapy",
  "counseling",
  "panic attacks",
  "insomnia",
  "stress management",
  "suicidal thoughts",
  "smoking cessation",
  "weight loss",
  "exercise routine",
  "diet plan",
  "low carb diet",
  "plant based diet",
  "intermittent fasting",
  "metformin",
  "lisinopril",
  "atorvastatin",
  "amlodipine",
  "levothyroxine",
  "sertraline",
  "omeprazole",
  "albuterol",
  "advair",
  "insulin",
  "glipizide",
  "celebrex",
  "tramadol",
  "ibuprofen",
  "acetaminophen",
  "naproxen",
  "x-ray",
  "MRI",
  "CT scan",
  "EKG",
  "blood pressure monitor",
  "glucose meter",
  "follow-up appointment",
  "telehealth",
  "in-person visit",
  "walk-in clinic",
  "urgent care",
  "primary care",
  "specialist referral"
];